import Post from './Post';
import { GET_POSTS_BY_USER_INTEREST } from '../../../frontend/graphQL/queries/post';
import { useApolloClient } from '@apollo/client';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, CircularProgress, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(() => ({
  scroll: {
    overflow: 'inherit !important',
  },
}));

const ForYou = ({ isLoggedIn, isVendor }) => {
  const classes = useStyles();
  const [posts, setPosts] = useState([]);
  const [postList, setPostList] = useState({ total: '', page: '' });
  const client = useApolloClient();
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client
      .query({
        query: GET_POSTS_BY_USER_INTEREST,
        variables: {
          page: 1,
          pageSize: 20,
        },
      })
      .then((res) => {
        setLoading(false);
        setPosts(res?.data?.getPostsByUserInterests?.data);
        setPostList({
          total: res?.data?.getPostsByUserInterests?.total,
          page: res?.data?.getPostsByUserInterests?.page,
        });
        if (
          res?.data?.getPostsByUserInterests?.data.length >=
          Number(res?.data?.getPostsByUserInterests?.total)
        ) {
          setHasMore(false);
          setLoading(false);
        }
      });
  }, []);

  const fetchData = () => {
    if (posts.length >= Number(postList.total)) {
      setHasMore(false);
      setLoading(false);
    }

    client
      .query({
        query: GET_POSTS_BY_USER_INTEREST,
        variables: {
          page: Number(postList?.page) + 1,
          pageSize: 20,
        },
      })
      .then((res) => {
        setLoading(false);
        setPosts([...posts, ...res?.data?.getPostsByUserInterests?.data]);
        setPostList({
          total: res?.data?.getPostsByUserInterests?.total,
          page: res?.data?.getPostsByUserInterests?.page,
        });
      });
  };

  if (loading) {
    return (
      <Grid style={{ textAlign: 'center', marginTop: '50%' }}>
        <CircularProgress size="3rem" />
      </Grid>
    );
  }
  return (
    <div>
      {posts && posts.length == 0 ? (
        <Grid style={{ textAlign: 'center', marginTop: '50%' }}>
          <Typography>No post available!!!</Typography>
        </Grid>
      ) : (
        <InfiniteScroll
          dataLength={posts?.length}
          next={fetchData}
          hasMore={hasMore}
          className={classes.scroll}
          loader={
            <Grid style={{ textAlign: 'center' }}>
              <CircularProgress size="2rem" />
            </Grid>
          }
        >
          {posts &&
            posts.map((post, index) => (
              <Post
                key={index}
                post={post}
                showSetting={false}
                isLoggedIn={isLoggedIn}
                isVendor={isVendor}
              />
            ))}
        </InfiniteScroll>
      )}
    </div>
  );
};

ForYou.propTypes = {
  isLoggedIn: PropTypes.bool,
  isVendor: PropTypes.bool,
};
export default ForYou;
